import React from "react";

const SolutionDataDriven = () => {
  return (
    <div className="about_area aws-solution">
      <div className="container">
        <div className="row">
         <div className="col-lg-8 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-20 text-left">
           
              <div className="section_main_title">
                <h3>Solution</h3>
              
              </div>
             
              
            </div>
            <div className="singel_about_left text-left">
              
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                <div className="singel-about-content">
                 
                  <p>
                 ProPlus Data designed a three-stage campaign combining contact intelligence, behavioural signals, and role-specific messaging.

                  </p>
                </div>
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 <p><b>Key Insights Uncovered:</b></p>
                  <p>
                  ● 45,000+ decision-maker contacts identified and enriched <br/>  ● 35,000+ accounts researched using technographics, intent signals, and buying patterns

                  </p>
                </div>
              </div>
             
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                 
                </div>
                <div className="singel-about-content">
                  
                  <p>
                 <b> Accounts segmented by buying readiness into:</b><br/>● High (H): 21%
                     <br/>● High-Medium (HM): 34%
                   <br/>● Medium (M): 45%

                  </p>
                </div>
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                 
                </div>
                <div className="singel-about-content">
                  
                  <p>
                This intelligence formed the foundation for prioritized outreach, ensuring resources were focused where conversion potential was highest.


                  </p>
                </div>
                
              </div>
               <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                <div className="singel-about-content">
                <div className="section_main_title">
                <h3>Execution</h3>
              
              </div>
                 <p><b>Email Campaigns:</b></p>
                  <p>
                  ● India: Focused on Generative AI & Cloud Modernization <br/>● ANZ + ASEAN: Emphasized Analytics & Data Governance</p>
                  <p>Ebooks were used to prime audiences before voice outreach, improving conversion readiness.
</p>

<p><b>Voice Outreach:</b></p>
                  <p>
                  ● 3 regional teams executed BANT-qualified conversations <br/>● 65% of calls reached mid to senior-level stakeholders <br/> ● Typical challenges uncovered: vendor lock-ins, recent migrations, outsourced IT operations</p>
                  <p>By mapping objections to strategic need states, we turned blockers into conversion opportunities.
</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-6">
            {/* <div className="section_title text_left mb-40 mt-3 text-left">
           
              <div className="section_main_title">
                <h2>ProPlus Data</h2>
              
              </div>
             
              
            </div> */}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionDataDriven;
